@if (true) {
    <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header BlueHeader">
                    <h4 class="Heading"> {{ModelFor}}</h4><br>
                    <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()"
                        data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="400 px" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
    <div class="table-header-container">
        <div class="table-heading">
            E-court Intigration
        </div>
        <div>
            {{CNR}}
        </div>
        <form [formGroup]="FormSearchLibrary"
        (ngSubmit)="onSearchLibrary(FormSearchLibrary.value)">
            <div class="d-flex align-items-center ">
                <div class="form-group">
                    <ng-select formControlName="advanceSearchValue" [items]="Court" bindLabel="MainDescr" bindValue="hdID"
                        placeholder="Select Court Type" (change)="CallPython()"></ng-select>
                </div>
                <div class="input-group">
                    <input type="text" placeholder="Search here..." class="table-search-input form-control"
                    formControlName="txtSearch"  (keyup.enter)="CallPython()">
                    <span class="input-group-btn">
                    <button class="btn btn-primary" title="Search" type="button" (click)="CallPython()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                    </span>
                </div>
                <div class="dropdown mx-2">
                    <button
                    class="btn btn-outline-primary dropdown-toggle"
                    type="button"
                    id="exportDropdown"
                    data-toggle="dropdown">

                    <i class="fas fa-download" style="margin-right:6px;"></i>
                    Export
                    </button>
                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="exportDropdown">

                        <button class="dropdown-item d-flex align-items-center"
                                type="button"
                                (click)="DownloadReport(8)">
                        <i class="fas fa-file-excel text-success me-2"></i>
                        Excel
                        </button>

                        <button class="dropdown-item d-flex align-items-center"
                                type="button"
                                (click)="DownloadReport(6)">
                        <i class="fas fa-file-csv text-primary me-2"></i>
                        CSV
                        </button>

                        <button class="dropdown-item d-flex align-items-center"
                                type="button"
                                (click)="DownloadReport(7)">
                        <i class="fas fa-file-code text-warning me-2"></i>
                        HTML
                        </button>

                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="page-sub-heading">
        Case Data
    </div>
    <div class="card">
        <table class="custom-table">
            <thead>
                <tr>
                    <th>Case Heading</th>
                    <th>CNR</th>
                    <th>Case Type</th>
                    <th>Filling No</th>
                    <th style="width:100px;">Filling Dt</th>
                    <th>Registration No</th>
                    <th>Registration Dt</th>
                    <th style="width:150px;">First Hearing Dt</th>
                    <th>Next Hearing Dt</th>
                    <th>Case Stage</th>
                    <th>Court Number Judge</th>
                    <th>Petitioner</th>
                    <th>Respondent </th>
                    <th>Acts</th>
                </tr>
            </thead>
            <tbody>
            <app-table-state
            [loading]="MsgType == 1"
            [error]="MsgType == 2 ? 'Something went wrong while fetching data.' : null"
            [empty]="filteredData?.length == 0"
            [rows]="10"
            [columns]="5">
            </app-table-state>
                @for (
                mDtl of (filteredData | paginate: { itemsPerPage: pageSize, currentPage: pageNumber });
                track mDtl.ID;
                let i = $index
                ) {
                <tr>
                    <td>{{ mDtl.CaseHeading }}</td>
                    <td>{{ mDtl.CNRNO }}</td>
                    <td>{{ mDtl.CaseTYPE }}</td>
                    <td>{{ mDtl.FillingNumber }}</td>
                    <td>{{ mDtl.Fillingdate }}</td>
                    <td>{{ mDtl.BenchNO }}</td>
                    <td>{{ mDtl.RegistrationDate }}</td>
                    <td>{{ mDtl.FirstHearingDate }}</td>
                    <td>{{ mDtl.NextHearingDate }}</td>
                    <td>{{ mDtl.CaseStage }}</td>
                    <td>{{ mDtl.CourtNumberJudge }}</td>
                    <td>{{ mDtl.LawyerName }}</td>
                    <td>{{ mDtl.RespondentAdvocate }}</td>
                    <td>{{ mDtl.ACT }}</td>

                    @if (RequestFrom === 'process') {
                    <td>
                        <a
                        target="_blank"
                        [routerLink]="['/notice', TypeHeader, mDtl.ID]">
                        Process
                        </a>
                    </td>
                    }

                    @if (RequestFrom === 'update') {
                    <td>
                        <button class="icon-btn icon-btn-primary" title="Edit">
                            <a
                            target="_blank"
                            [routerLink]="['/gnotice', TypeHeader, mDtl.ID]">
                             <i class="fa fa-pencil"></i>
                            </a>
                        </button>
                    </td>
                    }
                </tr>
                }

            </tbody>
        </table>
    </div>
    @if (MsgType == 0 && filteredData?.length > 0) {
        <div class="d-flex justify-content-between my-3 w-100">
          <div class="w-50">
            <app-rows-per-page
            [pageSize]="pageSize"
            [total]="totalRecords"
            [pageIndex]="pageNumber"
            (pageSizeChange)="onPageSizeChange($event)">
          </app-rows-per-page>
          </div>
        <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
      </div>
    }
    <div class="page-sub-heading mt-4">
    Case History
    </div>

    <div class="card">
    <table class="custom-table">
        <thead>
        <tr>
            <th>Judge</th>
            <th>Business Dt</th>
            <th>Hearing Dt</th>
            <th>Purpose Of Hearing</th>
        </tr>
        </thead>

        <tbody>

        <!-- ===== Table State (Loading / Error / Empty) ===== -->
        <app-table-state
            [loading]="MsgType === 1"
            [error]="MsgType === 2 ? DisplayMessage : null"
            [empty]="ECODEMASTERCASEHISTORY?.length == 0"
            [rows]="10"
            [columns]="4">
        </app-table-state>

        <!-- ===== Data Rows ===== -->
        @if (MsgType === 0) {
            @for (
            mDt2 of (ECODEMASTERCASEHISTORY | paginate: { itemsPerPage: 10, currentPage: caseHistoryPageNumber });
            track $index;
            let i = $index
            ) {
            <tr>
                <td>{{ mDt2.JUDGENAME }}</td>
                <td>{{ mDt2.BUSINESSDATE }}</td>
                <td>{{ mDt2.HEARINGDATE }}</td>
                <td>{{ mDt2.PURPOSEOFHEARING }}</td>
            </tr>
            }
        }

        </tbody>
    </table>
    </div>

    @if (ECODEMASTERCASEHISTORY?.length > 0) {
        <div class="d-flex align-items-center justify-content-end">
            <pagination-controls (pageChange)="caseHistoryPageNumber = $event"></pagination-controls>
        </div>
    }
    </div>
}@else {
    <!-- <my-content placeholder="navigation">
    
        <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>
    
        <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
            <div class="modal-dialog-FactSheet">
                <div class="modal-content">
                    <div class="modal-header BlueHeader">
                        <h4 class="Heading"> {{ModelFor}}</h4><br>
                        <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()"
                            data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body  col-sm-12 form-group">
                        <iframe width="100%" Height="400 px" [src]="modalURL|safe"></iframe>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12"
            style="background-color: #eee; margin-top: 10px; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">
            <div class="col-sm-6">
    
                <form #SearchLibrary="ngForm" [formGroup]="FormSearchLibrary"
                    (ngSubmit)="onSearchLibrary(SearchLibrary.value);">
    
                    <div class="col-sm-2 text-left height-34">e-Court Type</div>
                    <div class="col-sm-3">
                    <select class="form-control " formControlName="Court" (change)="onCourtSelect($event.target.value)">
                        <option value="0">[Not Selected] </option>
                        <option *ngFor="let mDtl of Court" value="{{mDtl.hdID}}">{{mDtl.MainDescr}}
                        </option>
                    </select>
                    </div>
    
                    <div class="col-sm-1 text-left height-34">{{CNR}}</div>
                    <div class="col-sm-4">
                        <input class="form-control" autofocus formControlName="txtSearch" placeholder="Search here"
                            [(ngModel)]="txtSearch" name="txtSearch" type="text" id="txtSearch">
                    </div>
                    <div class="col-sm-1">
    
                        <input class="btn btn-primary btn-sm-12" (click)="CallPython()" value="Search e-Court Data">
                    </div>
    
                </form>
            </div>
    
            <div class="col-sm-5">
                <input class="btn btn-primary" style="width: 70px; display: none;" autofocus (click)="GETECODEUPDATESHOW()"
                    value="Save">
            </div>
    
            <div class="col-sm-1">
                <a title="Download" class=" dropdown-toggle" href="#" id="navbarDropdown" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="material-icons">
                        save_alt
                    </i><span id="MaterialText">Export</span>
                </a>
                <div class="dropdown-menu" style="min-width: 100px;" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" role="button" (click)="this.DownloadReport(8)"><img
                            src="assets/resources/images/excel.jpg" class="imgicon" /> &nbsp; Excel</a>
                    <a class="dropdown-item" (click)="DownloadReport(6)"><img src="assets/resources/images/csv.png"
                            class="imgicon" /> &nbsp;&nbsp; CSV</a>
                    <a class="dropdown-item" (click)="DownloadReport(7)"><img src="assets/resources/images/htmlIcon3.png"
                            class="imgicon" /> &nbsp;&nbsp; HTML</a>
                </div>
            </div>
    
            <div class="col-sm-4"></div>
    
        </div>
    
    
        <div class="col-sm-12" style="margin-top: 8px;">
            <div class=" col-sm-12 lefticonD paddingless"
                style="border-left:1px solid #ccc;border-top:1px solid #ccc; border-right:1px solid #ccc;">
                <label>Case Data</label>
            </div>
            <table width="100%" class="LMtable table-responsive">
                <tr>
                    <th>Case Heading</th>
                    <th>CNR</th>
                    <th>Case Type</th>
                    <th>Filling No</th>
                    <th style="width:100px;">Filling Dt</th>
                    <th>Registration No</th>
                    <th>Registration Dt</th>
                    <th style="width:150px;">First Hearing Dt</th>
                    <th>Next Hearing Dt</th>
                    <th>Case Stage</th>
                    <th>Court Number Judge</th>
                    <th>Petitioner</th>
                    <th>Respondent </th>
                    <th>Acts</th>
                </tr>
    
                <tr *ngIf="this.MsgType == 1">
                    <td colspan="80">
                        <div class="d-flex align-items-center">
                            <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                            <div class="spinner-border" role="status"></div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 2">
                    <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                        <span>{{DisplayMessage}}</span>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 3">
                    <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                    </td>
                </tr>
                <ng-container *ngIf="this.MsgType == 0">
                    <tr
                        *ngFor="let mDtl of ECODEMASTER | paginate: { itemsPerPage: 10, currentPage: pageNumber }; let i=index">
                        <td> {{mDtl.CaseHeading}} </td>
                        <td> {{mDtl.CNRNO}} </td>
                        <td> {{mDtl.CaseTYPE}} </td>
                        <td> {{mDtl.FillingNumber}} </td>
                        <td> {{mDtl.Fillingdate}} </td>
                        <td> {{mDtl.BenchNO}} </td>
                        <td> {{mDtl.RegistrationDate}} </td>
                        <td> {{mDtl.FirstHearingDate}} </td>
                        <td> {{mDtl.NextHearingDate}} </td>
                        <td> {{mDtl.CaseStage}} </td>
                        <td> {{mDtl.CourtNumberJudge}} </td>
                        <td> {{mDtl.LawyerName}} </td>
                        <td> {{mDtl.RespondentAdvocate}} </td>
                        <td> {{mDtl.ACT}} </td>
                        <td *ngIf="this.RequestFrom == 'process'">
                            <a target="_blank" routerLink="/notice/{{TypeHeader}}/{{mDtl.ID}}">Process</a>
                        </td>
                        <td *ngIf="this.RequestFrom == 'update'">
                            <a target="_blank" routerLink="/gnotice/{{TypeHeader}}/{{mDtl.ID}}"><img
                                    src="assets/resources/images/edit.png"></a>
                        </td>
                    </tr>
                </ng-container>
            </table>
            <ng-container *ngIf="this.MsgType == 0">
                <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
                </ng-container>
    
        </div>
    
        <div class="col-sm-12" style="margin-top: 8px;">
    
            <div class=" col-sm-12 lefticonD paddingless"
                style="border-left:1px solid #ccc;border-top:1px solid #ccc; border-right:1px solid #ccc;">
                <label>Case History </label>
            </div>
            <table width="100%" class="LMtable">
                <tr>
    
                    <th>Judge</th>
                    <th>Business Dt</th>
                    <th>Hearing Dt</th>
                    <th>Purpose Of Hearing</th>
                </tr>
    
                <tr *ngIf="this.MsgType == 1">
                    <td colspan="80">
                        <div class="d-flex align-items-center">
                            <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                            <div class="spinner-border" role="status"></div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 2">
                    <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                        <span>{{DisplayMessage}}</span>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 3">
                    <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                    </td>
                </tr>
                <ng-container *ngIf="this.MsgType == 0">
                    <tr
                        *ngFor="let mDt2 of ECODEMASTERCASEHISTORY | paginate: { itemsPerPage: 10, currentPage: pageNumber }; let i=index">
    
                        <td> {{mDt2.JUDGENAME}} </td>
                        <td> {{mDt2.BUSINESSDATE}} </td>
                        <td> {{mDt2.HEARINGDATE}} </td>
                        <td> {{mDt2.PURPOSEOFHEARING}} </td>
                    </tr>
                </ng-container>
            </table>
            <ng-container *ngIf="this.MsgType == 0">
                <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
                </ng-container>
        </div>        
        <div><br></div>
    </my-content>
    <my-content placeholder="main">
    
    </my-content> -->
}